import { render, staticRenderFns } from "./List.vue?vue&type=template&id=65da823d&scoped=true&"
import script from "./List.vue?vue&type=script&lang=ts&"
export * from "./List.vue?vue&type=script&lang=ts&"
import style0 from "./List.vue?vue&type=style&index=0&id=65da823d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65da823d",
  null
  
)

export default component.exports